export function convertToKiddomHTMLStyle({ content }: { content: string }) {
  if (!content) return
  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'text/html')
  doc.querySelectorAll('[class]').forEach((element) => {
    element.removeAttribute('class')
    element.removeAttribute('style')
  })
  doc.querySelectorAll('p').forEach((element) => {
    element.textContent =
      element.textContent?.replace(/<\/?span[^>]*>/g, '') || ''
    element.after(doc.createElement('br'))
  })
  doc.querySelectorAll('li').forEach((element) => {
    element.innerHTML = `<p>${element.textContent?.replace(/<\/?span[^>]*>/g, '') || ''}</p>`
  })
  return doc.body
}
